module.exports = ".text {\n  font-size: 14px;\n  line-height: 25px;\n  color: #979797;\n  margin: 8px 0 16px;\n}"